import Grid from '@material-ui/core/Grid';
import Button from "@material-ui/core/Button";
import SwapCallsIcon from '@material-ui/icons/SwapCalls';
import { Typography } from "@material-ui/core";

type Props = {
    onTeamChangeButtonClick: () => void,
    onEditButtonClick: () => void
}

const CenterButtonArea = ({ onTeamChangeButtonClick, onEditButtonClick }: Props) => {
    return (
        <>
            <Grid item xs={5}>
                <Typography display="inline" variant="h4" style={{ color: "white", marginLeft: "10px", top: "50%", position: "relative", textAlign: "left" }}>Defence</Typography>
            </Grid>
            <Grid item xs={2} style={{
                textAlign: 'center',
                justifyContent: 'center',
                alignContent: 'center',
            }}>
                <Button variant="contained" color="default" onClick={onTeamChangeButtonClick}>
                    <SwapCallsIcon />攻守交代
                </Button>
            </Grid>
            <Grid item xs={5} style={{
                textAlign: 'right',
                justifyContent: 'right',
                alignContent: 'right',
                paddingBottom: 0
            }}>
                <Button variant="contained" color="primary" onClick={onEditButtonClick}>
                    編集
                </Button>
            </Grid>
        </>
    )
}

export default CenterButtonArea;
